var portfolioHeader = {
	baseCurrency: "Basiswährung",
	numberOfPositions: "Positionen",
	portfolioValue: "Portfoliowert in {currency}",
	todayChange: "Heutige Änderung",
	unrealizedPerformance: "Nicht realisierte G u V",
	purchaseValue: "Kaufwert",
	realizedProfits: "Realisierte Gewinne",
	totalValue: "Gesamtwert",
	totalPerformance: "Gesamtrendite",
	lastCalculationDateTime: "Letzte Berechnung"
};
var de = {
	portfolioHeader: portfolioHeader
};

export { de as default, portfolioHeader };
